import { LOGIN } from "./constants";
import { useWindowSize } from "./Hooks/useWindowSize";
import Home from "./Components/Pages/Home";
import Login from "./Components/Auth/Login/index";
import React, { useContext, useState } from "react";
import Register from "./Components/Auth/Register/index";
import UserContextProvider from "./Context/UserContext";

export default function App() {
  const { isAuth } = useContext(UserContextProvider);
  const { height } = useWindowSize();

  // 'login', 'register'
  const [state, setState] = useState(LOGIN);

  const authenticate = state === LOGIN ? <Login setAuthState={setState} /> : <Register setAuthState={setState} />;
  return <main style={{ height }}>{!isAuth ? authenticate : <Home />}</main>;
}
